export default __webpack_public_path__ + "static/iida-a8df336cc85b5e513c2de452ea32a140.jpg";